import { genericErrorToast } from '@/lib/toasts'
import { AiChatSessionsService } from '@/types/generated/services.gen'
import * as Sentry from '@sentry/vue'
import { ref } from 'vue'

/**
 * Composable for downloading a chat session as PDF.
 * Used by the three-dots menu "Chat als PDF herunterladen" action.
 */
export function useChatPdfExport() {
  const isExporting = ref(false)

  async function exportSessionPdf(sessionUuid: string): Promise<void> {
    if (isExporting.value) return

    isExporting.value = true
    try {
      const response = await AiChatSessionsService.aiChatSessionsExportPdfCreate({
        uuid: sessionUuid,
        requestBody: {
          attach_to_case: false
        }
      })

      if (!response.success || !response.content_base64) {
        genericErrorToast()
        return
      }

      const binaryString = atob(response.content_base64)
      const bytes = new Uint8Array(binaryString.length)
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }

      const blob = new Blob([bytes], { type: 'application/pdf' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = response.filename || `chat-${sessionUuid.substring(0, 8)}.pdf`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Failed to export PDF:', error)
      genericErrorToast()
      Sentry.captureException(error)
    } finally {
      isExporting.value = false
    }
  }

  return { isExporting, exportSessionPdf }
}
